'use strict';

export class UpcomingEvents {
    constructor() {

        // The MyABA Local group calendar feed


        (function () {
            var block = $('#block-views-block-group-nodes-local-group-events');

            if (block.length < 1) return;


            var calendarLink = block.find(".view-footer a");
            var refereceLink = $('.view-display-id-user_local_group_link_hidden');

            if (calendarLink.length < 1 || refereceLink.length < 1) return;

            var url = refereceLink.find('.views-field-title a').attr('href');

            calendarLink.attr('href', `${url}#calendar`)
        })();

        (function () {
            var block = $('#block-views-block-member-events-rest');

            if (block.length < 1 || block.find('.user-local-group-events .meta').length < 1) return;

            var meta = block.find('.user-local-group-events .meta').data();

            var template = $(
                `<div class="upcoming-event views-row">
            <div class="views-field views-field-field-type">
                <div class="field-content" data-attr="event_type"></div>
            </div>
            <div class="views-field views-field-title">
                <h4 class="field-content" data-attr="event_title"></h4>
            </div>
            <div class="views-field views-field-nothing">
                <div class="field-content upcoming-event-date">
                    <div class="upcoming-event-date--day" data-attr="event_day"></div>
                    <div class="upcoming-event-date--month" data-attr="event_month"></div>
                </div>
            </div>
            <div class="views-field views-field-view-node"><span class="field-content"></span></div>
        </div>`
            );

            $.ajax({
                url: meta.src,
                method: 'GET',
                success: function (response) {
                    if (response.length < 1) return;

                    var wrapper = $("<div/>", { class: '' });
                    response.forEach(item => {
                        item.event_type = item.event_type.toLowerCase();

                        // template
                        var templateClone = template.clone();
                        templateClone.attr('data-group', item.event_group);
                        templateClone.find("*[data-attr]").each(function (index) {
                            var attr = $(this).data('attr');
                            $(this).html(item[attr]);
                        });

                        templateClone.find('.views-field-view-node .field-content').html(
                            `<a href='${item.url}' hreflang='en'>More info</a>`
                        );
                        wrapper.append(templateClone);
                    });
                    block.find('.user-local-group-events .meta').after(wrapper);
                    block.css('display', 'block');

                    // Add link to calendar
                    if ($('.view-id-branch_details .views-field-title a').attr('href').length > 0) {
                        var $local_group_calendar = $('.view-id-branch_details .views-field-title a').attr('href') + "#calendar";
                        block.find('.view-footer a').attr('href', $local_group_calendar);
                    }
                },
                error: function (error) {
                    console.error(error);
                }
            })
        })();
    }
}
